<template>
  <FullPage>
    <Webview>
      <Header :leftTitle="channelName" :back="back">
        <div class="nav_btn" @click="toPage('member')"><img src="./img/member.svg"></div>
        <div class="nav_btn" @click="toPage('setting')"><img src="./img/menu.svg"></div>
      </Header>
      <div class="message_layer _fill">
        <div class="loading-top" v-show="!ready || loading.old">
          <div v-loading="true"></div>
        </div>
        <div class="message_frame">
          <template v-for="data in dataList">
            <!-- type: normal -->
            <div v-if="data.type === 'normal'" class="message_ctn">
              <div class="title_box">
                <div class="title">{{data.title}}</div>
                <div class="date">{{label("dataTime", data)}}</div>
              </div>
              <div class="content">{{data.content}}</div>
            </div>
            <!-- type: invitation -->
            <template v-if="data.type === 'invitation'">
              <div class="invitation_tag"><span :class="data.content.includes('退出') ? '_out' : '_in'">{{data.content}}</span></div>
            </template>
          </template>
        </div>
        <!-- 預覽最新message -->
        <div v-show="!isEnd && hasUnreadMessages" class="preview-last-message" @click="event_scroll('end')">
          <div class="text" line-clamp>{{lastMessage}}</div>
        </div>
        <!-- 向下箭頭按鈕 -->
        <div v-show="!isEnd && !hasUnreadMessages" class="scroll-down-btn" @click="event_scroll('end')">
          <img src="@img/arrow_down.svg" alt="scroll down">
        </div>
      </div>
    </Webview>

    <router-view />
    <Watch v-if="channel" :callback="init" />
  </FullPage>
</template>

<script>
//api
import { getMessages } from "@/api/channel";
//utils
import { moment2 } from "@u/methods";
const DISTANCE = 50;
const MAX_MESSAGE_LENGTH = 200;
export default {
  mixins: [
    require("@mix/channel").default,
    require("@mix/webview").default,
    require("@mix/timer").default,
  ],
  data() {
    return {
      ready: false,
      dataList: [],
      //scroll
      isEnd: true,
      //message
      loading: {
        old: false,
        new: false,
      },
      limit: 20,
      //old
      page: 0,
      oldCount: 0,
      //scroll
      container: undefined,
      oldHeight: 0,
      // 新增：追蹤當前未讀訊息數量
      currentUnreadCount: 0,
      // 新增：記錄初始載入的訊息數量
      initialMessageCount: 0,
      isLoadingMessages: false
    }
  },
  computed: {
    moment2: () => moment2,
    newTime() { return this.dataList[this.dataList.length - 1]?.dataTime || 0 },
    lastMessage() {
      let list = this.dataList.filter(data => data.type === "normal");
      return list[list.length - 1]?.content;
    },
    hasUnreadMessages() {
      return this.currentUnreadCount > 0;
    }
  },
  mounted() {
    // 因為有可能是從推播直接進來, 不需要 init, 只保留定時器
    // 如果從推播來的, 會在 @mix/webview 的 onMessage 中處理
    this.timer.push(setInterval(() => {
      if (!this.ready) return;
      this.getNewData();
    }, 1000))
  },
  methods: {
    back() {
      this.$router.replace({ path: "/channel" });
    },
    label(type, targetData) {
      if (type === "dataTime") {
        return moment2("local-datetime", targetData.dataTime);
      }
    },
    toPage(type) {
      switch (type) {
        case "member": this.$router.push({ path: `/channel/room/member/${this.channelID}` }); break;
        case "setting": this.$router.push({ path: `/channel/room/setting/${this.channelID}` }); break;
      }
    },
    async init() {
      try {
        // 確保 DOM 準備好
        await this.$nextTick();

        // 初始化捲動容器
        this.container = this.$el?.querySelector(".message_frame");
        if (!this.container) {
          console.error("找不到 message_frame 元素");
          return;
        }

        this.container.addEventListener("scroll", () => {
          if (this.container.scrollTop < DISTANCE) {
            this.oldHeight = this.container.scrollHeight;
            this.getOldData();
          }
          this.isEnd = (this.container.scrollHeight - this.container.scrollTop - this.container.clientHeight) <= 20;
          if (this.isEnd) {
            this.currentUnreadCount = 0;
            this.initialMessageCount = this.dataList.length;
          }
        });

        // 載入已讀訊息
        if (this.channel.totalCount) {
          this.oldCount = this.channel.totalCount - this.channel.unreadCount;
          if (this.oldCount > 0) {
            this.page = Math.max(Math.ceil(this.oldCount / this.limit) - 1, 1);
            await this.getReadData();
            this.initialMessageCount = this.dataList.length;
          }
        }

        // 載入未讀訊息
        if (this.channel.unreadCount) {
          this.isEnd = false;
          await this.getUnreadData();
          // 更新未讀訊息數量
          this.currentUnreadCount = this.channel.unreadCount;
          this.initialMessageCount = this.dataList.length - this.channel.unreadCount;
        }

        this.ready = true;

        // 根據未讀訊息數量決定捲動位置
        await this.$nextTick();
        if (this.channel.unreadCount > 0) {
          this.scrollToPosition('unread');
        } else {
          this.scrollToPosition('bottom');
        }
      }
      catch (ex) {
        console.error("init():", ex);
      }
    },
    event_scroll(type) {
      if (type === "init") {
        this.container = this.$el.querySelector(".message_frame");
        this.container.addEventListener("scroll", () => {
          //至頂加載
          if (this.container.scrollTop < DISTANCE) {
            this.oldHeight = this.container.scrollHeight;
            this.getOldData();
          }
          //是否至底
          this.event_scroll("isEnd");
        })
      }
      else if (type === "end") {
        // 使用 requestAnimationFrame 來確保在下一幀執行捲動
        requestAnimationFrame(() => {
          this.container.scrollTo({
            top: this.container.scrollHeight,
            behavior: 'smooth'
          });
        });
      }
      else if (type === "isEnd") {
        if (!this.ready) return;
        const isAtBottom = (this.container.scrollHeight - this.container.scrollTop - this.container.clientHeight) <= 20;
        this.isEnd = isAtBottom;

        // 如果滑到底部，清空未讀訊息計數
        if (isAtBottom) {
          this.currentUnreadCount = 0;
          this.initialMessageCount = this.dataList.length;
        }
      }
      else if (type === "scrollToRecord") {
        // 使用 requestAnimationFrame 來確保在下一幀執行捲動
        requestAnimationFrame(() => {
          const newHeight = this.container.scrollHeight;
          this.container.scrollTo({
            top: newHeight - this.oldHeight,
            behavior: 'smooth'
          });
        });
      }
    },
    // 捲動到指定位置
    scrollToPosition(position = 'bottom') {
      if (!this.container) return;

      if (position === 'bottom') {
        this.container.scrollTop = this.container.scrollHeight;
      } else if (position === 'unread') {
        // 計算未讀訊息開始的位置
        const unreadStartIndex = this.dataList.length - this.channel.unreadCount;
        if (unreadStartIndex >= 0) {
          const unreadStartElement = this.container.children[unreadStartIndex];
          if (unreadStartElement) {
            this.container.scrollTop = unreadStartElement.offsetTop - 20; // 稍微往上一些，讓使用者可以看到上下文
          }
        }
      }
    },
    getReadData() {
      let skip = (this.page - 1) * this.limit;
      const params = {
        skip: skip,
        limit: this.oldCount - skip
      }
      return getMessages(this.channelID, params).then(res => {
        this.dataList = res.data;
      })
    },
    getUnreadData() {
      const params = {
        skip: this.oldCount,
        limit: this.channel.unreadCount
      }

      this.loading.new = true;
      return getMessages(this.channelID, params).then(res => {
        this.dataList.push(...res.data);
      }).finally(() => {
        this.loading.new = false;
      })
    },
    getOldData() {
      if (this.loading.old) return;
      this.loading.old = true;
      this.page -= 1;
      if (this.page < 1) {
        this.loading.old = false;
        return;
      }
      const params = {
        skip: (this.page - 1) * this.limit,
        limit: this.limit,
      }
      return getMessages(this.channelID, params).then(res => {
        this.dataList.unshift(...res.data);
        this.event_scroll("scrollToRecord");
      }).finally(() => {
        this.loading.old = false;
      })
    },
    getNewData() {
      if (this.loading.new) return;
      const params = {
        limit: 0,
        startTime: this.newTime + 1
      }
      this.loading.new = true;
      return getMessages(this.channelID, params).then(res => {
        const newMessages = res.data;
        this.dataList.push(...newMessages);

        // 更新未讀訊息數量
        if (!this.isEnd) {
          // 如果不在底部，新訊息都算未讀
          this.currentUnreadCount += newMessages.length;
        } else {
          // 如果在底部，更新 initialMessageCount
          this.initialMessageCount = this.dataList.length;
          this.currentUnreadCount = 0;
        }

        if (this.isEnd) {
          if (this.dataList.length > MAX_MESSAGE_LENGTH) {
            this.dataList = this.dataList.slice(-MAX_MESSAGE_LENGTH);
            this.initialMessageCount = Math.max(this.initialMessageCount - (this.dataList.length - MAX_MESSAGE_LENGTH), 0);
          }
          this.scrollToPosition('bottom');
        }
      }).finally(() => {
        this.loading.new = false;
      })
    },
    //
    getData() {
      if (!this.ready) return;
      // 如果是從推播進來的, 會靠這個觸發
      // 推播進來前理論上 App 有延遲 3.5s 先去頻道列表初始化
      this.getNewData();
    }
  },
  watch: {
    channelID() {
      this.init();
    }
  }
}
</script>

<style lang="scss">
.message_layer {
  .loading-top {
    position: absolute;
    top: 0.5rem;
    left: 0;
    right: 0;
    .el-loading-mask {
      position: relative;
      background: none;
    }
    .el-loading-spinner {
      position: relative;
      top: 0;
      margin: 0;
      > svg {
        width: 1.5rem;
        height: auto;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.message_layer {
  position: relative;
  //預覽最新message
  .preview-last-message {
    @include buttonEnhance();
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ffffff;
    padding: 0.5rem 1rem;

    border-top: 1px solid $gray_90;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);

    .text {
      @include line_clamp(1);
      font-size: 60%;
    }
  }
  //向下箭頭按鈕
  .scroll-down-btn {
    position: absolute;
    right: -10px;
    bottom: 10px;
    transform: translateX(-50%);
    background-color: $gray_90;
    padding: 0.5rem;
    border-radius: 10%;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    img {
      width: 1rem;
      height: 1rem;
    }
  }
}
.message_frame {
  padding: 0.8rem 1rem;
  background-color: $gray_95;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  > * {
    &:not(:last-child) {
      margin-bottom: 0.4rem;
    }
  }
  .message_ctn {
    width: 100%;
    background-color: #ffffff;
    border-radius: 4px;
    border-bottom: 1px solid $gray_90;
    padding: 0.8rem;
    .title_box {
      display: flex;
      align-items: center;
      .title {
        font-size: 80%;
      }
      .date {
        font-size: 70%;
        color: $gray_70;
        margin-left: auto;
        letter-spacing: 0;
        white-space: pre;
      }
    }
    .content {
      font-size: 70%;
      color: $gray_60;
      margin-top: 0.4rem;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
    }
  }
  .invitation_tag {
    display: flex;
    justify-content: center;
    span {
      font-size: 70%;
      color: $gray_60;
      border-radius: 4px;
      padding: 0.2rem 0.6rem;
      &._in {
        background-color: #ffffff;
      }
      &._out {
        background-color: $gray_90;
      }
    }
  }
}
</style>